import sanitizeHtml from 'sanitize-html';

export function getWarpStyledBoldHtml(text: string): string {
    const config = {
        allowedTags: ['br', 'b', 'span', 'del'],
        allowedAttributes: { span: ['style'] },
    };

    const cleanHTML = sanitizeHtml(text, config);

    return cleanHTML
        .replace(/<b>/g, '<span class="font-bold">')
        .replace(/style="color:tjt-price-highlight"/g, 'class="s-text-positive"')
        .replace(/<\/b>/g, '</span>');
}

export function checkForUnhandeledTags(text: string, hasAlternative: boolean) {
    if (hasAlternative) return;
    if (!text.includes('<del>')) return;
    console.error(`Ops! The text "${text}" needs an altText to replace the use of the del-tag.`);
}
